import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/About.css';

const About = () => {
  const navigate = useNavigate();

  // Handle phone call
  const handleCall = () => {
    window.location.href = 'tel:+918019472678';
  };

  // Handle navigation to rooms page
  const handleExploreRooms = () => {
    navigate('/rooms');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="abt-about-section" id="about">
      <div className="abt-about-container">
        <div className="abt-about-wrapper">
          {/* Left Side - Image */}
          <div className="abt-about-image-wrapper">
            <div className="abt-about-image-main">
              <img 
                src="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="AA GRAND HOTEL Luxury Interior"
              />
              <div className="abt-about-image-overlay"></div>
              
              {/* Floating Badge */}
              <div className="abt-about-float-badge">
                <span className="abt-float-icon">⭐</span>
                <div>
                  <strong>4.8/5</strong>
                  <p>Guest Rating</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="abt-about-content">
            <span className="abt-about-badge">✦ About Us</span>
            <h2 className="abt-about-title">
              Where Luxury Meets <span className="abt-highlight">Hospitality</span>
            </h2>
            
            <p className="abt-about-description">
              AA GRAND HOTEL — where every stay becomes a cherished memory. 
              Experience world-class luxury, warm hospitality, and comfort in the heart of Hyderabad.
            </p>

            {/* Quick Info - Address */}
            <div className="abt-about-quick-info">
              <div className="abt-info-item">
                <span className="abt-info-icon">📍</span>
                <div>
                  <h4>Location</h4>
                  <p>Ameerpet Metro Pillar No. 1072</p>
                </div>
              </div>
              <div className="abt-info-item">
                <span className="abt-info-icon">🕐</span>
                <div>
                  <h4>Check-in / Check-out</h4>
                  <p>12:00 PM / 11:00 AM</p>
                </div>
              </div>
            </div>

            {/* Feature Tags */}
            <div className="abt-about-tags">
              <span className="abt-tag">🛏️ Luxury Rooms</span>
              <span className="abt-tag">🍽️ Fine Dining</span>
              <span className="abt-tag">📍 Prime Location</span>
              <span className="abt-tag">💎 5-Star Service</span>
              <span className="abt-tag">🚗 Free Parking</span>
              <span className="abt-tag">📶 Free WiFi</span>
            </div>

            {/* CTA Buttons */}
            <div className="abt-about-cta-group">
              <button onClick={handleExploreRooms} className="abt-about-cta-primary">
                Explore Rooms →
              </button>
              <button onClick={handleCall} className="abt-about-cta-secondary">
                📞 Call Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;